import { useState } from 'react';

interface InfoBannerProps {
  message: string;
  actionLabel?: string;
  onAction?: () => void;
  onDismiss?: () => void;
}

export default function InfoBanner({
  message,
  actionLabel,
  onAction,
  onDismiss,
}: InfoBannerProps) {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div
      className="flex items-center gap-[var(--sp-3)] px-[var(--sp-4)] py-[var(--sp-3)] text-[13px] animate-[slideDown_250ms_ease-out]"
      style={{
        background: 'var(--color-surface-action-medium-default)',
        color: 'var(--color-text-action-strong-default)',
      }}
    >
      <i className="icon icon-app-info-circle" style={{ fontSize: 16 }} />
      <span className="flex-1">{message}</span>
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          className="font-semibold text-[13px] cursor-pointer hover:underline"
          style={{ color: 'var(--color-text-action-strong-default)' }}
        >
          {actionLabel}
        </button>
      )}
      {onDismiss && (
        <button
          onClick={() => {
            setVisible(false);
            onDismiss();
          }}
          className="cursor-pointer p-[var(--sp-1)]"
          aria-label="Dismiss"
          style={{ color: 'var(--color-text-action-strong-default)' }}
        >
          <i className="icon icon-app-close" style={{ fontSize: 16 }} />
        </button>
      )}
    </div>
  );
}
